export default __webpack_public_path__ + "static/media/properties-living-room.4813cc00.png";